import React from 'react'
import moment from 'moment'

import { A, Div, H5, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const PageEvent = ({event, name}) => {
  return (
    <Div className="contact-event--container">
      <Div className="contact-event--icon">
        <Icon name="location-2" width={20} height={20}/>
      </Div>
      <Div className="contact-event--event-description">
        <H5>
          {name} viewed the page at <A href={event.body.attributes.url} target="_blank" rel="noopener noreferrer">{event.body.attributes.url}</A>
        </H5>
        <Span>{moment(event.createdAt).format('MM/DD/YYYY hh:mm A')}</Span>
      </Div>
    </Div>
  )
}

export default PageEvent
